import React from 'react';

function Loader() {
	return (
		<div className="spinnercont spinnercont--g">
			<div className="spinner spinner--g"></div>
		</div>
	);
}

export default Loader;
